import { createEmptyCollection } from 'helpers/normalizeHelpers'
import { Reducer } from 'interfaces'
import { CreditCardDataState } from 'components/features/creditCard/creditCardStore/state'
import { GetCCUpcomingPaymentsAction } from 'components/features/creditCard/creditCardStore/actions'

const INITIAL_STATE = createEmptyCollection()
export const ccUpcomingPaymentsReducer: Reducer<CreditCardDataState['upcomingPayments']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case GetCCUpcomingPaymentsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return action.payload.response
    }
  }

  return prevState
}
